import React from 'react';
import styled from 'styled-components';
import { DialogPlugin, MessagePlugin } from 'tdesign-react';
import { changeCurrentProvideServiceCluster } from '@/services/serviceDiscoveryService';
import ClusterItem from './ClusterItem';

export default function ClusterGroup({ cluster, recoveryCluster, doRefresh }) {
  const handleSwitch = async (params) => {
    const dialog = DialogPlugin.confirm({
      header: '提示',
      theme: 'warning',
      body: '确定切换服务发现地址？',
      confirmBtn: {
        content: '确定',
      },
      onClose: () => dialog.hide(),
      onConfirm: async () => {
        try {
          dialog.update({
            confirmBtn: { loading: true, content: '确定' },
          });
          await changeCurrentProvideServiceCluster(params);
          MessagePlugin.success('操作成功！');
          dialog.hide();
          doRefresh();
        } catch (error) {
          console.trace(error);
          throw error;
        } finally {
          dialog.update({
            confirmBtn: { loading: false, content: '确定' },
          });
        }
      },
    });
  };

  return (
    <Root>
      <ClusterItem
        primary
        {...cluster}
        handleSwitch={() =>
          handleSwitch({
            primaryClusterName: cluster.clusterName,
            recoveryClusterName: '',
            currentProvideServiceCluster: cluster.clusterName,
          })
        }
      />
      <Hr />
      <ClusterItem
        {...recoveryCluster}
        handleSwitch={() =>
          handleSwitch({
            primaryClusterName: cluster.clusterName,
            recoveryClusterName: '',
            currentProvideServiceCluster: recoveryCluster.clusterName,
          })
        }
      />
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Hr = styled.div`
  height: 25px;
  width: 0;
  border-right: 2px dashed rgba(1, 1, 1, 0.25);
`;
